import { render, staticRenderFns } from "./channelClient.vue?vue&type=template&id=3f1987bc&scoped=true"
import script from "./channelClient.vue?vue&type=script&lang=js"
export * from "./channelClient.vue?vue&type=script&lang=js"
import style0 from "./channelClient.vue?vue&type=style&index=0&id=3f1987bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1987bc",
  null
  
)

export default component.exports